// extracted by mini-css-extract-plugin
export var info = "PortfolioOverview-module--info--fa682";
export var section = "PortfolioOverview-module--section--cf413";